import loadable from '@loadable/component';

export const ErrorLoadable = loadable(() => import('./Error'), {
  fallback: undefined, // @TODO Добавить фолбек
  ssr: false,
});
